'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useBranding = undefined;

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

(function () {
  var enterModule = require('react-hot-loader').enterModule;

  enterModule && enterModule(module);
})();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _branding = require('../services/branding');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var useBranding = exports.useBranding = function useBranding(accessToken, shouldUseBranding) {
  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isBrandingLoading = _useState2[0],
      setBrandingLoading = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      brandingInfo = _useState4[0],
      setBrandingInfo = _useState4[1];

  (0, _react.useEffect)(function () {
    if (accessToken && shouldUseBranding) {
      setBrandingLoading(true);
      (0, _branding.fetchBrandingInfo)(accessToken).then(function (branding) {
        setBrandingLoading(false);
        setBrandingInfo(branding);
      }).catch(function (reason) {
        setBrandingLoading(false);
        setBrandingInfo(null);
      });
    }
  }, [accessToken, shouldUseBranding]);
  return {
    isBrandingLoading: isBrandingLoading,
    brandingInfo: brandingInfo
  };
};

;

(function () {
  var reactHotLoader = require('react-hot-loader').default;

  var leaveModule = require('react-hot-loader').leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useBranding, 'useBranding', 'src/branding/useBranding.jsx');
  leaveModule(module);
})();

;